import { useLayoutEffect, useEffect } from 'react';

import { isBrowser as _isBrowser } from '../utils/isBrowser.js';

/**
 * useSafeLayoutEffect enables us to safely call `useLayoutEffect` on the browser
 * (for SSR reasons)
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser.
 *
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/main/packages/hooks/src/use-safe-layout-effect.ts}
 * @see {@link https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85}
 * @public
 */
export const useSafeLayoutEffect = _isBrowser ? useLayoutEffect : useEffect;
